import { useCallback, useEffect, useState } from 'react';

// https://stackoverflow.com/questions/48048957/react-long-press-event (3rd answer)
export const useLongPress = (callback = () => {}, ms = 400) => {
  const [startLongPress, setStartLongPress] = useState(false);
  const [touchLocation, setTouchLocation] = useState({ top: null, left: null });

  useEffect(() => {
    let timerId;
    if (startLongPress) {
      timerId = setTimeout(() => callback(touchLocation), ms);
    } else {
      clearTimeout(timerId);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [callback, ms, startLongPress, touchLocation]);

  const start = useCallback((e) => {
    const touch = e.touches[0];
    setStartLongPress(true);
    setTouchLocation({ top: touch.pageY, left: touch.pageX });
  }, []);
  const stop = useCallback(() => {
    setStartLongPress(false);
    setTouchLocation({ top: null, left: null });
  }, []);

  return {
    onTouchStart: start,
    onTouchEnd: stop,
  };
};
